import React from "react";
import Spinner from "components/generales/Spinner";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Boton from "components/boton/Boton";
import { useNavigate } from "react-router-dom";
import "components/generales/Styles.css";
import Navbar from "components/generales/Navbar";
import axios from "axios";

const VerCuenta = () => {
  const [cuenta, setCuenta] = useState({});
  const [cargando, setCargando] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    setCargando(!cargando);
    const obtenerCuentaAPI = async () => {
      try {
        const token = localStorage.getItem("token");
        const url = `https://mymoney5.herokuapp.com/cuentas/${id}`;
        const { data } = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCuenta(data);
      } catch (error) { }
      setCargando(false);
    };
    obtenerCuentaAPI();
  }, []);
  return cargando ? (
    <Spinner />
  ) : Object.keys(cuenta).length === 0 ? (
    <p>No hay resultados</p>
  ) : (
    <>
      <Navbar />

      <div className="lista-preview">
        <h2>Información de la cuenta</h2>

        {/* Completar con información del video 175 */}

        <table>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Tipo</th>
              <th>CVE</th>
              <th>
                {cuenta?.tipo_cuenta === "Wallet"
                  ? "Clave pública"
                  : "Número de cuenta"}
              </th>
              <th>Saldo actual</th>
              <th>Fecha de corte</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>{cuenta.nombre}</td>
              <td>{cuenta.tipo_cuenta}</td>
              <td>{cuenta.cve}</td>
              <td>
                {cuenta?.tipo_cuenta === "Wallet"
                  ? cuenta?.numero_cuenta
                  : cuenta?.numero_cuenta}
              </td>
              <td>{`$ ${cuenta.saldo}`}</td>
              <td>{new Date(cuenta.fecha_corte).toISOString().slice(0, 10)}</td>
            </tr>
          </tbody>
        </table>
        <Boton
          type="button"
          buttonStyle="botonTransparente"
          onClick={() => navigate(`/cuentas`)}
        >
          Regresar
        </Boton>
      </div>
    </>
  );
};

export default VerCuenta;
